import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Rules from './components/Rules';
import Game from './components/Game';
import Gift from './components/Gift';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function Home() {
  const [isGameCompleted, setIsGameCompleted] = useState(false);

  useEffect(() => {
    const completed = localStorage.getItem('snowmanCompleted');
    if (completed === 'true') {
      setIsGameCompleted(true);
    }
  }, []);

  const handleGameComplete = () => {
    setIsGameCompleted(true);
    localStorage.setItem('snowmanCompleted', 'true');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-blue-50">
      <Navbar />
      <Hero />
      <Rules />
      <Game onComplete={handleGameComplete} isCompleted={isGameCompleted} />
      <Gift isUnlocked={isGameCompleted} />
      <FAQ />
      <Contact />
    </div>
  );
}
